import { render, staticRenderFns } from "./AppointmentsSignUp.vue?vue&type=template&id=9adf319c&scoped=true"
import script from "./AppointmentsSignUp.vue?vue&type=script&lang=ts"
export * from "./AppointmentsSignUp.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentsSignUp.vue?vue&type=style&index=0&id=9adf319c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adf319c",
  null
  
)

export default component.exports